module.exports = __webpack_public_path__ + "static/media/Nile Buisness Tower Still 11.a792f5ac.webp";